import React, { Component } from 'react'
import { Modal, Form, Input, message, Spin, Row } from 'antd'
import axios from 'axios'
import ColorPicker from '../../Widgets/ColorPicker'
import { SimpleUploader } from '../../Widgets/Uploaders'
import { UploadOutlined } from '@ant-design/icons'


class SubproyectoForm extends Component {
  formRef = React.createRef()

  state = { loading: false }

  componentDidMount() {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
    const { subproyecto_id } = this.props
    if (subproyecto_id) this.getSubproyecto()
  }

  getSubproyecto = async () => {

    this.setState({ loading: true })

    try {

        const { data: sub } = await axios.get(
            `/subproyectos/${this.props.subproyecto_id}`
        )
        this.formRef.current.setFieldsValue({
            nombre: sub.nombre,
            descripcion: sub.descripcion,
            color: sub.color,
            logo: sub.logo,
        })

    } catch (err) {

      console.error(err)
      message.error('Error al cargar el subproyecto')

    } finally {

      this.setState({ loading: false })

    }
  }

  onFinish = async (values) => {

    this.setState({ loading: true })

    try {

        const formData = new FormData()
        formData.appendMultiple({
            proyecto_id: this.props.proyecto_id,
            ...values
        })

        if (this.props.subproyecto_id) {

        formData.append('id', this.props.subproyecto_id)

        await axios.put('/subproyectos', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        message.success('Subproyecto actualizado');
        } else {

            await axios.post('/subproyectos', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            message.success('Subproyecto creado');

      }

      this.props.onClose()
      
    } catch (err) {

      console.error(err)
      message.error('Error al guardar el subproyecto')

    } finally {

      this.setState({ loading: false })

    }
  }

  render() {
    return (
      <Form
        id="form-subproyecto"
        layout="vertical"
        ref={this.formRef}
        onFinish={this.onFinish}
      >
        <Spin spinning={this.state.loading}>

            <Row align="center" className="width-100">
              <Form.Item
                  name="logo"
                  className="width-100"
              >
                  <SimpleUploader
                      url={axios.defaults.baseURL + '/subproyectos/logo/'}
                      _id={this.props.subproyecto_id}
                      uploadTitle="Subir Logo de Subproyecto"
                      imageCrop={false}
                      uploadContent={<div style={{ textAlign: "center", backgroundColor: "#fafafa", border: "1px dashed #d9d9d9", padding: "1em", borderRadius: "5px" }}>
                          <UploadOutlined style={{ color: "currentcolor", fontSize: 24 }} />
                          <div className="ant-upload-text">Subir Logo de Subproyecto</div>
                      </div>}
                      buttonDelete={false}
                      uploaderProps={{
                          listType: null,
                          showUploadList: true,
                      }}
                      remove={true}
                  />
              </Form.Item>
            </Row>
    
            <Form.Item
                name="nombre"
                label="Nombre"
                rules={[{ required: true, message: 'Ingresa el nombre' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item name="descripcion" label="Descripción">
                <Input />
            </Form.Item>

            <Form.Item name="color" label="Color">
                <ColorPicker />
            </Form.Item>

        </Spin>
      </Form>
    )
  }
}

export default function ModalSubproyectos(props) {
  const { open = false, onClose = () => {}, subproyecto_id, proyecto_id } = props

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={subproyecto_id ? 'Editar Subproyecto' : 'Crear SubProyecto'}
      destroyOnClose
      okText="Guardar"
      cancelText="Cancelar"
      okButtonProps={{ form: 'form-subproyecto', htmlType: 'submit' }}
    >
      <SubproyectoForm {...{ subproyecto_id, proyecto_id, onClose }} />
    </Modal>
  )
}
